import { Controller } from "@hotwired/stimulus"

// Manages the lead creation form: toggles new-member fields based on
// combobox selection and auto-fills the opportunity title.
export default class extends Controller {
  static targets = ["memberFields", "title", "firstName", "lastName"]

  connect() {
    this.titleManuallyEdited = false
    this.selectedMemberName = null

    if (this.hasTitleTarget) {
      this.titleTarget.addEventListener("input", this.markTitleEdited)
    }
  }

  disconnect() {
    if (this.hasTitleTarget) {
      this.titleTarget.removeEventListener("input", this.markTitleEdited)
    }
  }

  // Fired by forms--combobox via custom event on the form element
  memberSelected(event) {
    const { label, id } = event.detail || {}

    if (id) {
      this.selectedMemberName = (label || "").split(" — ")[0].trim()
      if (this.hasMemberFieldsTarget) {
        this.memberFieldsTarget.classList.add("hidden")
        this.memberFieldsTarget.querySelectorAll("input").forEach((i) => (i.disabled = true))
      }
      this.setTitle(this.selectedMemberName)
    } else {
      this.clearMemberSelection()
    }
  }

  // Called when any form field fires change; we only care about the member_id hidden field
  memberIdChanged(event) {
    if (!event.target.name?.includes("member_id")) return
    if (!event.target.value) {
      this.clearMemberSelection()
    }
  }

  // Called on input in first_name / last_name fields
  updateTitle() {
    if (this.titleManuallyEdited || this.selectedMemberName) return

    const first = this.hasFirstNameTarget ? this.firstNameTarget.value.trim() : ""
    const last = this.hasLastNameTarget ? this.lastNameTarget.value.trim() : ""
    const name = `${first} ${last}`.trim()

    if (this.hasTitleTarget && name.length > 0) {
      this.suppressTitleEdit = true
      this.titleTarget.value = name
      this.dispatchFloatingLabel(this.titleTarget)
      this.suppressTitleEdit = false
    }
  }

  // -- private helpers --

  clearMemberSelection() {
    this.selectedMemberName = null
    if (this.hasMemberFieldsTarget) {
      this.memberFieldsTarget.classList.remove("hidden")
      this.memberFieldsTarget.querySelectorAll("input").forEach((i) => (i.disabled = false))
    }
  }

  setTitle(name) {
    if (this.titleManuallyEdited || !this.hasTitleTarget) return
    if (!name) return

    this.suppressTitleEdit = true
    this.titleTarget.value = name
    this.dispatchFloatingLabel(this.titleTarget)
    this.suppressTitleEdit = false
  }

  markTitleEdited = () => {
    if (this.suppressTitleEdit) return
    this.titleManuallyEdited = true
  }

  dispatchFloatingLabel(input) {
    input.dispatchEvent(new Event("input", { bubbles: true }))
    input.dispatchEvent(new Event("focus", { bubbles: true }))
    input.dispatchEvent(new Event("blur", { bubbles: true }))
  }
}
